<template>
  <!-- Marks a cancellation statement whose registry statement PDF is kept private
       (DEV-583). Shared by the review modal and the order-detail modal so the two
       read identically. Margin is left to the caller (class fallthrough). -->
  <span
    class="badge rounded-pill bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle"
  >
    <FontAwesomeIcon icon="lock" class="me-1" />
    {{ $t("go_cancel.private_pill") }}
  </span>
</template>
